const minPriceValues = [
    { 
        value: '0', 
        en: 'Min Price', 
        th: 'ราคาขั้นต่ำ', 
        cn: '最低价格', 
        ru: 'Минимальная цена', 
        de: 'Mindestpreis', 
        fr: 'Prix minimum',
        ja: '最低価格',
        ko: '최소 가격',
        es: 'Precio mínimo',
        tr: 'Minimum Fiyat',
        he: 'מחיר מינימלי',
        ar: 'أقل سعر',
        it: 'Prezzo minimo'
    },
    '100000', '150000', '250000', '500000', '750000', '1000000', '1250000', '1500000', 
    '1750000', '2000000', '2250000', '2500000', '2750000', '3000000', '3250000', 
    '3500000', '3750000', '4000000', '4500000', '5000000', '5500000', '6000000', 
    '6500000', '7000000', '8000000', '9000000', '10000000', '11000000', '12000000', 
    '13000000', '15000000', '17500000', '20000000', '22500000', '25000000', 
    '30000000', '35000000', '40000000', '60000000', '80000000', '100000000', 
    '150000000', '200000000', '300000000', '500000000'
];

const languages = ['en', 'th', 'cn', 'ru', 'de', 'fr', 'ja', 'ko', 'es', 'tr', 'he', 'ar', 'it'];

/**
 * Generates the saleMinPrices object for all supported languages.
 */
export const saleMinPrices = languages.reduce((acc, lang) => {
    acc[lang] = minPriceValues.map(item => {
        if (typeof item === 'object') {
            return { value: item.value, nom: item[lang] };
        }
        
        // Formatting logic
        let formattedNom;
        if (lang === 'fr') {
            // French: Space separator
            formattedNom = Number(item).toLocaleString('fr-FR').replace(/\u202f/g, ' ');
        } else if (lang === 'tr' || lang === 'de') {
            // Turkish and German: Often use periods as thousand separators
            formattedNom = Number(item).toLocaleString('tr-TR');
        } else if (lang === 'it') {
            // Italian: Periods as thousand separators, comma as decimal
            formattedNom = Number(item).toLocaleString('it-IT');
        } else {
            // Default to commas (English, Thai, Chinese, Hebrew, Arabic, etc.)
            formattedNom = Number(item).toLocaleString('en-US');
        }
        return {
            value: item,
            nom: formattedNom
        };
    });
    return acc;
}, {});